<template>
  <div id="daily-grade" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
    <div class="daily-filter">
      <div class="date-filter">
        <el-date-picker v-model="dateStr" type="date" ref='dateInput' value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="请选择选择日期">
        </el-date-picker>
        <i class="iconfont icon-jiantou" @click="$refs.dateInput.handleFocus()"></i>
      </div>
    </div>
    
    <div class="in-and-out clearfix">
      <div class="tit">同期报表</div>
      <div class="pie">
        <div class="income left">
          <div class="panle-tit">所选时间数据,{{nowDate}},{{week[ringDay]}}</div>
          <div class="panle-info">
            <ul>
              <li v-for="(item,index) in startSalesItem" :key="index">
                <span>{{item.typeName}}</span>
                <span>数量：{{item.qty}}</span>
                <span class="right">金额：￥{{item.amount}}</span>
              </li>
            </ul>
            <div v-if="startSalesItem.length==0">暂无数据</div>
          </div>
        </div>
        <div class="out left">
          <div class="panle-tit">同期数据,{{ringDate}},{{week[ringDay]}}</div>
          <div class="panle-info">
            <ul>
              <li v-for="(item,index) in endSalesItem" :key="index">
                <span>{{item.typeName}}</span>
                <span>数量：{{item.qty}}</span>
                <span class="right">金额：￥{{item.amount}}</span>
              </li>
            </ul>
            <div v-if="endSalesItem.length==0">暂无数据</div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="loading">

    </div>
  
  </div>
</template>

<script>

export default {
  name: "ringReport",
  props: ["curStoreId"],
  data() {
    return {
      dateStr: new Date().Format("yyyy-MM-dd"),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() + 24 * 60 * 60 * 1000 > Date.now();
        }
      },
      week:['星期天','星期一','星期二','星期三','星期四','星期五','星期六'],
      startSalesItem:[],
      endSalesItem:[],
      nowDate:"",
      ringDate:"",
      nowDay:0,//星期
      ringDay:0,//星期
    };
  },
  watch: {
    dateStr(val) {
      console.log(new Date(val).Format("yyyy-MM-dd"));
      let nowDate = new Date(val).Format("yyyy-MM-dd");
      let prevTime = new Date(val).getTime() - 7 * 24 * 60 * 60 * 1000;
      let prevDate = new Date(prevTime).Format("yyyy-MM-dd");

      let date = new Date(val);
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      let day = date.getDate();

      // 同期时间
      let ringDateTimestamp = date.getTime() - 7 * 24 * 60 * 60 * 1000;
      let ringDate = new Date(ringDateTimestamp);
      let ringMonth = ringDate.getMonth() + 1;
      let ringYear = ringDate.getFullYear();
      let ringDay = ringDate.getDate();

      this.nowDay = date.getDay();
      this.ringDay = ringDate.getDay();

      this.nowDate = month + "月" + day + "日";
      this.ringDate = ringMonth + "月" + ringDay + "日";


      this.dateStr = nowDate;
      this.getData(`${nowDate} 00:00:00`,`${prevDate} 00:00:00`);
    }
  },
  methods:{
    getData(nowDate,prevDate){
      this.$http({
        url:"get-sales",
        method:"GET",
        params:{
          storeId:this.curStoreId,
          startTime:nowDate,
          endTime:prevDate
        }
      }).then(res=>{
        this.startSalesItem = res.data.startSalesItem;
        this.endSalesItem = res.data.endSalesItem;
      });
    }
  },
  activated() {

    //初始化时间
    let date = new Date();
    //获取当前时间（不包含时分秒）的时间戳
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let day = date.getDate();
    let nowTimestamp = new Date(`${year}/${month}/${day}`).getTime();
    //计算出昨天的时间戳,之前只能查询前一天的数据，所以这里计算了一下时间，现在可以查当日的数据
    let prevDateTimestamp = nowTimestamp- 24 * 60 * 60 * 1000;
    // 同期时间
    let ringDateTimestamp = prevDateTimestamp - 7 * 24 * 60 * 60 * 1000;


    let prevDate = new Date(prevDateTimestamp);
    let prevMonth = prevDate.getMonth() + 1;
    let prevYear = prevDate.getFullYear();
    let prevDay = prevDate.getDate();


    // 同期时间
    let ringDate = new Date(ringDateTimestamp);
    let ringMonth = ringDate.getMonth() + 1;
    let ringYear = ringDate.getFullYear();
    let ringDay = ringDate.getDate();

    this.nowDate = prevMonth + "月" + prevDay + "日";
    this.ringDate = ringMonth + "月" + ringDay + "日";
    this.nowDay = prevDate.getDay();
    this.ringDay = ringDate.getDay();

    let dateParam = `${prevYear}-${prevMonth>9?prevMonth:'0'+prevMonth}-${prevDay>9?prevDay:'0'+prevDay} 00:00:00`;
    let ringDateParam = `${ringYear}-${ringMonth>9?ringMonth:'0'+ringMonth}-${ringDay>9?ringDay:'0'+ringDay} 00:00:00`;
    this.dateStr = `${prevYear}-${prevMonth>9?prevMonth:'0'+prevMonth}-${prevDay>9?prevDay:'0'+prevDay}`;
    this.getData(dateParam,ringDateParam);
  },
};
</script>

<style lang="scss" scoped>
@import "./ringReport.scss";
</style>



// WEBPACK FOOTER //
// ringReport.vue?779efa8c